import {
  NpcInboundFreightState,
  NpcInboundFreightAction,
  NpcInboundFreightActionTypes,
} from '../../types/npcIboundFreight';

const initialState: NpcInboundFreightState = {
  shipping: {
    qtyShipped: 0,
    amount: 0,
    averageAmount: 0,
    total_chart: [],
    shipping_brand: [],
  },
  brands: {
    table: [],
    chart: [],
    total: {},
  },
  brand: {
    table: [],
    items_table: [],
    total: {},
  },
  lists: {
    brands: [],
    categories: [],
    sizes: [],
  },
  analytics: [],
  po: [],
  min_date: null,
  loading_lists: true,
  loading_brand: false,
  loading_brands: true,
  loading_shipping: true,
  loading_analytics: true,
  loading_po: true,
};

export const npcInboundFreightReducer = (
  state = initialState,
  action: NpcInboundFreightAction
): NpcInboundFreightState => {
  switch (action.type) {
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_SHIPPING:
      return {
        ...state,
        shipping: {
          ...state.shipping,
          ...action.payload,
        },
        loading_shipping: false,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRANDS:
      return {
        ...state,
        brands: {
          ...state.brands,
          ...action.payload,
        },
        loading_brands: false,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND:
      return {
        ...state,
        brand: {
          ...state.brand,
          ...action.payload,
        },
        loading_brand: false,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS:
      return {
        ...state,
        brand: {
          ...state.brand,
          ...action.payload,
        },
        loading_brand: false,
      };

    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PARAMS:
      return {
        ...state,
        lists: {
          ...state.lists,
          ...action.payload,
        },
        loading_lists: false,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_MINDATE:
      return {
        ...state,
        min_date: action.payload,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_ANALYTICS:
      return {
        ...state,
        analytics: action.payload,
        loading_analytics: false,
      };
    case NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PO:
      return {
        ...state,
        po: action.payload,
        loading_po: false,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING:
      return {
        ...state,
        loading_shipping: true,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING:
      return {
        ...state,
        loading_brands: true,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_LOADING:
      return {
        ...state,
        loading_brand: true,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING:
      return {
        ...state,
        loading_brand: true,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING:
      return {
        ...state,
        loading_analytics: true,
      };
    case NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_PO_LOADING:
      return {
        ...state,
        loading_po: true,
      };
    case NpcInboundFreightActionTypes.CLEAR_NPC_INBOUND_FREIGHT:
      return initialState;
    default:
      return state;
  }
};
